import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

/* eslint-disable react/no-did-mount-set-state */
import React, { Component, createRef } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Translate from '../Translate';
import Link from '../Link';

/**
 * `Cuttable` component is used for showing and hiding part of content.
 * @since 0.0.42
 */
var Cuttable =
/*#__PURE__*/
function (_Component) {
  _inherits(Cuttable, _Component);

  function Cuttable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Cuttable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Cuttable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      collapsed: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "contentRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function () {
      _this.setState(function (_ref) {
        var collapsed = _ref.collapsed;
        return {
          collapsed: !collapsed
        };
      });
    });

    return _this;
  }

  _createClass(Cuttable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var content = this.contentRef.current;

      if (content && content.scrollHeight > content.clientHeight) {
        this.setState({
          collapsed: this.props.collapsed
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          baseClassName = _this$props.baseClassName,
          className = _this$props.className,
          children = _this$props.children,
          collapsed = _this$props.collapsed,
          maxHeight = _this$props.maxHeight,
          locale = _this$props.locale,
          props = _objectWithoutProperties(_this$props, ["baseClassName", "className", "children", "collapsed", "maxHeight", "locale"]);

      var showMoreLessKey = this.state.collapsed ? 'showMore' : 'showLess';
      return React.createElement("div", _extends({
        className: classNames(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--collapse"), this.state.collapsed === true), _defineProperty(_classNames, "".concat(baseClassName, "--expand"), this.state.collapsed === false), _classNames), className)
      }, props), React.createElement("div", {
        className: "".concat(baseClassName, "__content"),
        style: {
          maxHeight: maxHeight
        },
        ref: this.contentRef
      }, children), this.state.collapsed !== undefined && React.createElement("div", {
        className: "".concat(baseClassName, "__action")
      }, React.createElement(Link, {
        onClick: this.handleToggle
      }, React.createElement(Translate, {
        content: "Cuttable.".concat(showMoreLessKey),
        fallback: locale[showMoreLessKey]
      }))));
    }
  }]);

  return Cuttable;
}(Component);

_defineProperty(Cuttable, "defaultProps", {
  collapsed: true,
  maxHeight: '7rem',
  locale: {
    showMore: 'Show more',
    showLess: 'Show less'
  },
  baseClassName: "".concat(CLS_PREFIX, "cuttable")
});

export default Cuttable;